import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { PaginatedMCPConnectionList } from 'types';
import { client } from 'utils/api-client';

export const MCP_CONNECTIONS_QUERY_KEY = 'ai-connections';

// The active connections for the session's gym. The endpoint is gym-scoped server-side
// (GymFilterBackend), so the caller never passes a gym.
export default function useMCPConnections(
  enabled = true,
): UseQueryResult<AxiosResponse<PaginatedMCPConnectionList>> {
  return useQuery([MCP_CONNECTIONS_QUERY_KEY], () => client.get('mcp-connections/'), { enabled });
}
